import { UiModalVanila } from '@skillbox/front-box/dist/Modals/UiModal/UiModalVanila.js';
import { closePopupGtmTag } from '../../libs/gtm';

export default class UiModal extends UiModalVanila {
  constructor(slot, options, classes = {}) {
    super(slot, { ...options, closeHandler: closePopupGtmTag }, classes);
  }
};
